var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Users",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23.333,
    viewBox: "0 0 21 23.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_perm_contact_calendar_24px",
    d: "M21.667,3.333H20.5V1H18.167V3.333H8.833V1H6.5V3.333H5.333A2.333,2.333,0,0,0,3,5.667V22a2.333,2.333,0,0,0,2.333,2.333H21.667A2.34,2.34,0,0,0,24,22V5.667A2.34,2.34,0,0,0,21.667,3.333ZM13.5,6.833a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,13.5,6.833Zm7,14H6.5V19.667c0-2.333,4.667-3.617,7-3.617s7,1.283,7,3.617Z",
    transform: "translate(-3 -1)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.94f1e51d06d8a82768416a471663738c.svg";
export { ForwardRef as ReactComponent };